export default __webpack_public_path__ + "static/media/garlic.92dfda26.jpg";